import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  allSpaInfoSelector,
  allSpaTreatmentsSelector,
  allSpaCategoriesSelector,
  selectedHotelCurrencySelector,
} from '../../../../property/propertySlice';
import {
  TREATMENTS_EDIT,
  SPA_TREATMENT_TAB_LIST,
  TYPE_VALUES,
} from '../../../../../constants/SpaConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_SPA,
} from '../../../../../constants/RoleConsts';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import RedirectUrlLink from '../../../../../shared/redirect-url-link/Redirect-Url-Link';
import { decodeMediaKeyValue } from '../../../../../utils/mediaUtils';

const TreatmentsView = (props) => {
  const { treatments, onViewToggle, hotelId, toggleDrawer, permissions } = props;
  const currency = useSelector(selectedHotelCurrencySelector);
  const [tabValue, setTabValue] = useState(0);
  const [selectedTreatment, setSelectedTreatment] = useState();
  const originalSpaInfo = useSelector(allSpaInfoSelector);
  const originalSpaCategory = useSelector(allSpaCategoriesSelector);
  const originalSpaTreatments = useSelector(allSpaTreatmentsSelector);

  useEffect(() => {
    if (hotelId && treatments.id) {
      let treatmentObj = {
        ...originalSpaTreatments.find((tempTreatment) => tempTreatment.id === treatments.id),
      };
      treatmentObj['category'] = {
        ...originalSpaCategory.find(
          (tempCategory) => tempCategory.id === treatmentObj.spaCategoryId,
        ),
      };
      treatmentObj['spaInfo'] = {
        ...originalSpaInfo.find((tempSpaInfo) => tempSpaInfo.id === treatmentObj.spaId),
      };
      setSelectedTreatment(treatmentObj);
    }
  }, [hotelId, originalSpaTreatments]);

  const onClickEdit = (event) => {
    toggleDrawer(TREATMENTS_EDIT, true, selectedTreatment);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return (
      <div className='mx-4'>
        {tabValue === 0 && (
          <>
            <div className='row mt-4 mb-2'>
              <div className='col-md-6'>
                <div className='details-label'>Treatment Name</div>
                <div className='details-value preview-breaks'>{selectedTreatment?.name}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Treatment Code</div>
                <div className='details-value'>{selectedTreatment?.code}</div>
              </div>
            </div>
            <div className='row mt-4 mb-2'>
              <div className='col-md-6'>
                <div className='details-label'>Spa Name</div>
                <div className='details-value'>
                  {selectedTreatment?.spaInfo?.name ? selectedTreatment.spaInfo.name : '---'}
                </div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Category Name</div>
                <div className='details-value'>
                  {selectedTreatment?.category?.name ? selectedTreatment.category.name : '---'}
                </div>
              </div>
            </div>
            <div className='row mt-4 mb-2'>
              <div className='col-md-12'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>{selectedTreatment?.description}</div>
              </div>
            </div>
            <div className='row mt-4 mb-2'>
              <div className='col-md-12'>
                <div className='details-label'>Disclaimer</div>
                <div className='details-value'>
                  {selectedTreatment?.disclaimer ? selectedTreatment?.disclaimer : '---'}
                </div>
              </div>
            </div>
            <div className='row mt-4 mb-2'>
              <div className='col-md-6'>
                <div className='details-label'>Treatment Type</div>
                <div className='details-value'>{TYPE_VALUES[selectedTreatment?.type]}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Redirect URL</div>
                {selectedTreatment?.redirectUrl ? (
                  <RedirectUrlLink url={selectedTreatment?.redirectUrl} />
                ) : (
                  <div className='redirect-url'>---</div>
                )}
              </div>
            </div>
            <div className='row mt-4'>
              {selectedTreatment?.customAttributes &&
                selectedTreatment?.customAttributes?.length > 0 &&
                selectedTreatment?.customAttributes?.map((item, index) => (
                  <div key={index} className='col-md-6 mb-2'>
                    <div className='details-label'>{item?.key}</div>
                    <div className='details-value'>{item?.value}</div>
                  </div>
                ))}
            </div>
          </>
        )}
        {tabValue === 1 && (
          <>
            <div className='row mt-4 mb-2'>
              <div className='col-md-4'>
                <div className='details-label'>Duration & Price</div>
                {selectedTreatment?.duration?.length > 0 ? (
                  selectedTreatment?.duration?.map((item, index) => (
                    <div className='details-value mb-1' key={index}>
                      {item?.duration} Minutes - {item?.price} {currency}
                    </div>
                  ))
                ) : (
                  <div>---</div>
                )}
              </div>
            </div>
          </>
        )}
        {tabValue === 2 && (
          <>
            <div className='row pt-4'>
              <MediaViewer
                images={selectedTreatment?.images || []}
                videos={(() => {
                  const { Video: videoMediaContent } = decodeMediaKeyValue(
                    selectedTreatment?.mediaContent,
                  );
                  return videoMediaContent || selectedTreatment?.videos || {};
                })()}
                gifs={(() => {
                  const { GIF: gifMediaContent } = decodeMediaKeyValue(
                    selectedTreatment?.mediaContent,
                  );
                  return gifMediaContent || selectedTreatment?.gifs || {};
                })()}
              />
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <>
      {selectedTreatment && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={SPA_TREATMENT_TAB_LIST}
          onViewToggle={onViewToggle}
          title={selectedTreatment.name}
          createdUserId={selectedTreatment.createdBy}
          isEditable={permissions[RBAC_TYPE_HOTEL_SPA] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
          tabClass='col-md-5'
          isHeightIncluded={true}
        />
      )}
    </>
  );
};

export default TreatmentsView;
